// extracted by mini-css-extract-plugin
export var addToCartButton = "_ot-b";
export var arrowButtonContainer = "_ot-9";
export var arrowButtonIcon = "_ot-a";
export var carouselArrowButton = "_ot-6";
export var carouselElementContainer = "_ot-1";
export var left = "_ot-7";
export var productDisplayCarouselContainer = "_ot-0";
export var productTileContainer = "_ot-2";
export var productTileImage = "_ot-4";
export var productTileImageContainer = "_ot-3";
export var productTileTitle = "_ot-5";
export var right = "_ot-8";
export var sliderOverflow = "_ot-c";